<template>
    <div :class="['search-locator-list', 'pt-2', { 'loading': isStatus('loading'), 'is-empty': items.length === 0 }]">
        <div class="search-locator-list-placeholder" v-if="items.length === 0">
            <slot name="placeholder" :items="items" @select="doSelect"  v-on:click="doSelect"></slot>
        </div>
        <div class="search-locator-list-header" v-else>
            <slot></slot>
        </div>
        <div class="search-locator-list-items">
            <slot name="list" :items="items" @select="doSelect"  v-on:click="doSelect">
                <div
                    :class="['search-locator-list-item', 'col-12', 'p-3', 'border-top', 'border-secondary', {
                        'disabled': isDisabled(item),
                        'selected': isSelected(item),
                    }]"
                    @click.prevent="doSelect(item)"
                    :id="item.attrId"
                    :key="item.id"
                    v-for="item in items"
                >
                    <h3  class="text-light " style="font-size: 1.125rem; font-weight: 300; max-height: 32px; display: inline;">{{ item.title }}</h3>
                    <div class="row pb-1 list-categories">
                        <span v-if="item.maintenance_center === '1'" class="col-auto border border-white py-1 my-1 item-category">{{ labels.maintenance_center }}</span>
                        <span v-if="item.dealer_sales_representative === '1'" class="col-auto border border-white py-1 my-1 item-category">{{ labels.dealer_sales_representative }}</span>
                        <span v-if="item.demo_helicopter === '1'" class="col-auto border border-white py-1 my-1 item-category">{{ labels.demo_helicopter }}</span>
                        <span v-if="item.helicopter_school === '1'" class="col-auto border border-white py-1 my-1 item-category">{{ labels.helicopter_school }}</span>
                    </div>
                    <span class="col-12 item-data">{{ item.phone }}</span>
                    <br>
                    <span class="col-12 item-data">{{ item.address }}</span>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import { scrollTo } from '../helpers/utils';
import { withStatus } from '@cherrypulp/vue-utils';

export default {
    mixins: [ withStatus() ],

    props: {
        items: {
            default() {
                return [];
            },
            type: Array,
        },
        labels: {
            default() {
                return [];
            },
        },
    },



    data() {
        return {
            selected: null,
        };
    },

    methods: {
        reload(items){
            console.log(items)
        },
        doSelect(item = null, fireEvent = true) {

            console.log('SearchLocatorList -> doSelect', item);
            this.selected = item;
            this.scrollToSelected(item);

            if (fireEvent) {
                this.$emit('select', item);
            }
        },

        isDisabled(item) {
            return !!item.disabled;
        },

        isSelected(item) {
            return this.selected && item && this.selected.id === item.id;
        },

        scrollToSelected(item) {
            if (item) {
                // Scroll to the activated store
                const target = document.getElementById(item.attrId);

                if (target) {
                    const offset = target.offsetTop - 20;

                    scrollTo(
                        this.$el,
                        offset,
                        300
                    );
                }
            }
        },
    },

    mounted() {
        this.setStatus('ready', true);
        console.log(this.items)
    },
};
</script>

<style lang="scss">
.item-category {
    margin-right: 1rem;
    text-align: center;
    font-size: 0.6875rem;
}
.item-data{
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 24px;
}
.list-categories{
    padding-left: 1rem;
}
.search-locator-list {
    overflow: hidden;
    //overflow-y: scroll;
    scroll-behavior: smooth;

    .search-locator-list-placeholder,
    .search-locator-list-header,
    .search-locator-list-items {
        display: flex;
        width: 100%;
    }

    .search-locator-list-placeholder {
        text-align: center;
    }

    .search-locator-list-header {
        padding-left: 15px;
        padding-right: 15px;
    }

    .search-locator-list-items {
        display: flex;
        flex-wrap: wrap;
    }

    .search-locator-list-item {
        padding: 10px;

        &.disabled {
            color: #555;
        }
        &.selected {
            background-color: #363636;
        }
    }
}
</style>
